import * as d3 from "d3";
import { DataDRequest } from "../../data/DRequest";
import { Entidad } from "../../data/Entidad";
import { DataModuloMain } from "../../data/ModuloMain";
import { _DICC_ALUMNO, _DICC_ALUMNO_FULL } from "../../data/modulo/Alumno";
import { _FinanzasObtenerPagosRecibidos } from "../../data/modulo/FinanzasPagosRecibidos";
import { DateV2 } from "../../util/DateV2";
import _L from "../../util/Labels";
import { IConfigGridExcelExport, IGridExtraTableConfig, IGridRenderInfo, VentanaGrid } from "../controlD3/AVentanaGrid";
import { ElementWrapper } from "../controlD3/ElementWrapper";
import { ExcelThings } from "../controlD3/ExcelExport";
import { SelectV2 } from "../controlD3/SelectV2";
import { Table } from "../controlD3/Tabla";
import { HTMLTooltipComponent } from "../controlWC/TooltipComponent";
import { UIUtilFormat } from "../util/Format";
import { UIUtilLang } from "../util/Language";
import { UIUtilTime } from "../util/Time";
import { UIUtilGeneral } from "../util/Util";
import { UIUtilViewData } from "../util/ViewData";
import { UIUtilViewFinanzasIngresoUtil } from "../utilView/FinanzasIngresos/FinanzasIngresoUtil";
import { _GenerarResumenPDFModal } from "../utilView/FinanzasPagosRecibidos/GenerarResumenPDFModal";
import { CFinanzasTabs } from "./AlumnosPanelV2";

import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;

type IItemComboYear = UIUtilViewFinanzasIngresoUtil.IItemComboYear
type IItemComboMonth = UIUtilViewFinanzasIngresoUtil.IItemComboMonth
type IFinanzaPagoRecibidoDetalleBase = Entidad.IFinanzaPagoRecibidoDetalle;
type IFinanzaPagoRecibidoBase = Entidad.IFinanzaPagoRecibido;

export interface IPagoRecibidoDetalle extends IFinanzaPagoRecibidoDetalleBase {
    IDFolio: string;
    PadreCargo: IPagoRecibidoCargo;
    StrMetodoPago: string;
    /** Valor pagado */
    Valor: number;
    KinderFiltro: number[];
    AlumnoEstado: Entidad.CNinioMovimiento
    get ValorCargo(): number;
    get DescuentoTotalCargo(): number;
    get ValorFaltanteCargo(): number;
    get ConceptoCargo(): string;
    get FechaVencimientoCargo(): string;
    get FechaAplicacionCargo(): string;
    get FechaPago(): string;
    get ZonaHoraria(): string;
    get NombreCompletoAlumno(): string;
    get StrEscuela(): string;
}

interface IPagoRecibidoCargo extends IFinanzaPagoRecibidoBase {
    Detalles: IPagoRecibidoDetalle[];
    // NombreCompletoAlumno: string;
    // DescuentoTotal: number;
    // ValorFaltante: number;
    // StrEscuela: string;
}

export class UIVentanaFinanzasPagosRecibidosV2 extends VentanaGrid<IPagoRecibidoDetalle> {
    private comboYear: SelectV2<IItemComboYear, "Id", "multiselect">;
    private comboMonth: SelectV2<IItemComboMonth, "Id", "multiselect">;
    private bolIncluyeExAlumnos: boolean = false;
    private dataPagosBySchool: Map<number, IPagoRecibidoDetalle[]>;

    private forceDownloadData: boolean;

    constructor(content: d3.Selection<HTMLDivElement, any, HTMLElement, any>, modulo: Entidad.CModulo) {
        super(content, modulo);
    }

    protected GridInitTable() {
        this.dataPagosBySchool = new Map();

        super.GridInitTable();
        this.AjustaDrawGrid();
        this.forceDownloadData = true;
    }

    private AjustaDrawGrid() {
        // Area combos-filtros
        let filterCont = this.ctrlTabla._Control.select(".filter_container");
        let searchwrapper = filterCont.select(".search-wrapper");

        let areaCombos = filterCont.append("div")
            .attr("class", UIUtilGeneral.FBoxOrientation.Horizontal)
            .style("column-gap", "calc(var(--padding2) * 4)")
            .style("padding", "0 var(--padding3) var(--padding2)")
            .style("box-sizing", "border-box")

        this.comboYear = (() => {
            const select = new SelectV2<IItemComboYear, "Id", "multiselect">({
                Parent: areaCombos,
                Type: "multiselect",
                ValueMember: "Id",
                DisplayMember: "Name",
                ListWidth: "200px",
                Data: () => UIUtilViewFinanzasIngresoUtil._ObtenerAniosDisponibles(this.kinders),
                OnChange: () => {
                    const monthsA = [...this.comboMonth._dataitems.map(d => d.Id)]
                    this.comboMonth._RefreshList()
                    if (this.comboMonth._dataSelected.length == 0) {
                        this.comboMonth._SelectAll(true)
                    } else {
                        const monthsB = [...this.comboMonth._dataitems.map(d => d.Id)]
                        const monthsSelect: string[] = []
                        for (const mB of monthsB) {
                            if (monthsA.includes(mB)) {
                                continue
                            }
                            monthsSelect.push(mB)
                        }
                        this.comboMonth._valueSelect(this.comboMonth._dataValueMemberSelected.concat(...monthsSelect))
                    }
                    this.forceDownloadData = false
                    this.GridUpdateData()
                }
            })
            areaCombos.append(() => {
                return ElementWrapper._WrapperToSelectControl(select, _L("time.anio") + ":")
                    .style("height", "35px")
                    .node();
            })
            return select
        })();
        this.comboMonth = (() => {
            const select = new SelectV2<IItemComboMonth, "Id", "multiselect">({
                Type: "multiselect",
                Parent: areaCombos,
                ValueMember: "Id",
                DisplayMember: "Name",
                ListWidth: "200px",
                Data: () => {
                    const idYears = this.comboYear._dataValueMemberSelected
                    return UIUtilViewFinanzasIngresoUtil._ObtenerMesesDisponibles(idYears)
                },
                OnChange: () => {
                    this.forceDownloadData = false
                    this.GridUpdateData()
                }
            })
            areaCombos.append(() => {
                return ElementWrapper._WrapperToSelectControl(select, _L("time.mes") + ":").node();
            })
            return select
        })();
        (() => {
            const tooltip: HTMLTooltipComponent = document.createElement("wc-tooltip") as HTMLTooltipComponent
            const input = document.createElement("input")
            input.type = "checkbox"
            input.id = "incluir_alumnos"
            input.onchange = () => {
                this.ctrlProgressBar.node()._Visible = true
                this.bolIncluyeExAlumnos = input.checked
                this.GridUpdateData()
                if (this.bolIncluyeExAlumnos)
                    tooltip.textContent = _L("finanzaspagosrecibidos.noincluir_exalumnos_desc")
                else
                    tooltip.textContent = _L("finanzaspagosrecibidos.incluir_exalumnos_desc")
            }
            tooltip.textContent = _L("finanzaspagosrecibidos.incluir_exalumnos_desc")
            areaCombos.append(() => {
                const wrapper = ElementWrapper._WrapperToElement(input, _L("finanzaspagosrecibidos.incluir_exalumnos"), {
                    LabelMaxWidth: "100%",
                    HideSeparator: true,
                }).node()
                wrapper.style.flex = "1"
                input.style.cursor = "pointer"
                wrapper.appendChild(tooltip)
                return wrapper
            })
        })();

        searchwrapper.raise()

        this.ctrlTabla._Control.select(".space_pie")
            .classed("hide", false)
            .style("display", "flex")
            .style("justify-content", "end")
            .text(_L("finanzaspagosrecibidos.tag_totalpagado") + ": " + UIUtilFormat._CurrencyFmt(0));

        // INIT VALUES
        this.comboYear._SelectAll(true)
        this.comboMonth._RefreshList()
        this.comboMonth._SelectAll(true)
        this.GridUpdateData()
    }

    private UpdateCurrentMonthTotal(data: Table.TDataItemTableAux<IPagoRecibidoDetalle>[]) {
        const total = this.CalcularTotal_Tabla(data);
        this.ctrlTabla._Control
            .select(".space_pie")
            .text(_L("finanzaspagosrecibidos.tag_totalpagado") + ": " + UIUtilFormat._CurrencyFmt(total));
    }

    public _OnServiceEvent(requestID: DataModuloMain.TipoRequestMonitorId) {
        super._OnServiceEvent(requestID);
        if (requestID == Entidad.CTipoRequest.Alumno) {
            // this.UpdateGridData(true);
            this.forceDownloadData = false;
            this.GridUpdateData();
        }
    }

    // ***********************************************************************
    // Modal Form
    // ***********************************************************************


    // ***********************************************************************
    // Table config
    // ***********************************************************************

    protected GRID_GetMenuTopGrid(): Table.ITableMenuTopDefaultOptionConfig[] {
        return [{
            Label: this.VB_GetUIStringModule("generarresumen_opc"),
            Callback: () => _GenerarResumenPDFModal(this.dataGrid),
            GetDetails: () => {
                let enable = this.dataGrid.length > 0; //this.ctrlTabla ? (this.ctrlTabla.prop_data.length > 0) : false;
                let description = enable ? "" : this.VB_GetUIStringModule("generarresumen_err1");
                return {
                    Enabled: enable,
                    Description: description
                }
            }
        }];
    }
    protected GRID_GetSelectionDataMenuV2(menuLocation: "row" | "top-selected", dataGridSelected: IPagoRecibidoDetalle[]): Table.ITableMenuDataSelectedOptionConfig<IPagoRecibidoDetalle>[] {
        return [{
            Label: this.VB_GetUIStringModule("generarresumen_opc"),
            Callback: (datos) => _GenerarResumenPDFModal(datos),
        }];
    }
    protected GRID_GetDataRequestID(): DataModuloMain.TipoRequestMonitorId {
        return null;
    }

    protected GRID_GetTableConfigBase(): IGridRenderInfo<IPagoRecibidoDetalle> {
        return {
            IdTabla: "FinanzasIngresos-PagosRecibidos",
            Title: "",
            DefaultSort: "NombreCompletoAlumno",
            ItemGrouperField: "IDFolio",
            IdData: "Id",
            MinWidth: 1700,
            Columns: [
                { Field: "IDFolio", Label: "Folio", MinWidth: "60px", Width: "5%" },
                { Field: "NombreCompletoAlumno", Label: "Alumn@", MinWidth: "100px", Width: "13%" },
                { Field: "ConceptoCargo", Label: "Concepto", MinWidth: "80px", Width: "13%" },
                { Field: "ValorCargo", Label: "Total de cargo", MinWidth: "80px", Width: "8%" },
                { Field: "DescuentoTotalCargo", LabelLangKey: "d_field_descuentototal", Label: "Total de descuento", MinWidth: "95px", Width: "8%" },
                { Field: "ValorFaltanteCargo", LabelLangKey: "d_field_valorfaltante", Label: "Total por cobrar", MinWidth: "80px", Width: "8%" },
                { Field: "Valor", Label: "Pagado", MinWidth: "80px", Width: "8%", OrderField: "Valor", OrderTypeParse: Number },
                { Field: "StrMetodoPago", Label: "Método pago", MinWidth: "100px", Width: "9%", OrderTypeParse: String },
                { Field: "FolioPago", Label: "Folio pago", MinWidth: "80px", Width: "9%", OrderTypeParse: String },
                { Field: "FechaPago", Label: "Fecha pago", MinWidth: "80px", Width: "9%", OrderTypeParse: Date },
                { Field: "FechaAplicacionCargo", LabelLangKey: "d_field_fechaaplicacion", Label: "Fecha aplicación", MinWidth: "90px", Width: "8%", OrderTypeParse: Date },
                { Field: "FechaVencimientoCargo", LabelLangKey: "d_field_fechavencimiento", Label: "Fecha vencimiento", MinWidth: "100px", Width: "8%", OrderTypeParse: Date },
                { Field: "StrEscuela", Label: "Escuela", MinWidth: "80px", Width: "9%" },
            ]
        }
    }

    protected GRID_GetTableConfigAdvanced(): IGridExtraTableConfig<IPagoRecibidoDetalle> {
        return {
            OnEndUpdateDataInView: (currentDataInTable, dataChecked) => {
                let pagos: Table.TDataItemTableAux<IPagoRecibidoDetalle>[] = [];
                currentDataInTable.forEach(dP => {
                    pagos.push(dP);
                });
                dataChecked.forEach(dP => {
                    pagos.push(dP);
                });
                this.UpdateCurrentMonthTotal(pagos);
            },
            EvaluatorAndSubLevelsBuild: <Table.IStepEvaluator<IPagoRecibidoDetalle, never, never>>{
                OnStepCellTable: (container, pago, field: (keyof IPagoRecibidoDetalle)) => {
                    switch (field) {
                        case "NombreCompletoAlumno":
                            if (_DICC_ALUMNO.has(pago.PadreCargo.IdAlumno))
                                UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", pago.PadreCargo.IdAlumno, pago.NombreCompletoAlumno);
                            else
                                container.text(pago.NombreCompletoAlumno)
                            break;
                        case "ValorCargo":
                        case "Valor":
                        case "ValorFaltanteCargo":
                            container.text(UIUtilFormat._CurrencyFmt(pago[field]));
                            break;
                        case "DescuentoTotalCargo":
                            UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", pago.PadreCargo.IdAlumno, UIUtilFormat._CurrencyFmt(pago[field] || 0), null, CFinanzasTabs.EdoCuenta);
                            break;
                        case "FechaPago": // Pago
                            container.text(UIUtilTime._DateFormatStandarFixTimeZone(pago[field], pago.ZonaHoraria, "dd/mm/yyyy h24:mm"));
                            break;
                        case "FechaAplicacionCargo":
                        case "FechaVencimientoCargo":
                            container.text(UIUtilTime._DateFormatStandarFixTimeZone(pago[field], pago.ZonaHoraria));
                            break;
                    }
                },
            }
        }
    }

    protected GRID_GetFilters(): Array<Table.IParametroFiltro<IPagoRecibidoDetalle>> {
        return [
            { Field: "IDFolio", Label: "ID" },
            { Field: "NombreCompletoAlumno", Label: "Nombre" },
            { Field: "AlumnoEstado", Label: "AlumnoEstado", Type: "select", Options: UIUtilViewData._GetList_EstadosMovimientos() },
            {
                Field: "ConceptoCargo", Label: "Concepto", Type: "select",
                Options: () => DataModuloMain._GetReqDataArrayByName("FinanzaCargo")
                    .map(d => ({ Id: d.Nombre, Name: d.Nombre }))
                    .concat(this.ctrlTabla._data.map(d => ({ Id: d.PadreCargo.Concepto, Name: d.PadreCargo.Concepto })))
                    .filter(d => (!!d.Name))
                    .sort((a, b) => d3.ascending(a.Name.toLowerCase(), b.Name.toLowerCase())),
            },
            { Field: "ValorCargo", Label: "Total de cargo $", Type: "number" },
            { Field: "DescuentoTotalCargo", LabelLangKey: "d_field_descuentototal", Label: "Total de descuento $", Type: "number" },
            { Field: "ValorFaltanteCargo", LabelLangKey: "d_field_valorfaltante", Label: "Total por cobrar $", Type: "number" },
            { Field: "Valor", Label: "Pagado $", Type: "number", OnGetValueToMatch: (dato: IPagoRecibidoDetalle) => [dato.Valor] },
            {
                Field: "StrMetodoPago", Label: "Método de pago", Type: "select",
                Options: () => DataModuloMain._GetReqDataArrayByName("FinanzaMetodoPago")
                    .map(d => ({ Id: d.Nombre, Name: d.Nombre }))
                    .sort((a, b) => d3.ascending(a.Name.toLowerCase(), b.Name.toLowerCase())),
            },
            { Field: "FolioPago", Label: "Folio de pago" },
            {
                Field: "FechaPago", Label: "Fecha pago", Type: "date-time", OnGetValueToMatch: (d) => ([
                    new DateV2(d.FechaPago)._SetTimeZoneByIdSchool(d.KinderFiltro[0])
                ])
            },
            { Field: "FechaAplicacionCargo", LabelLangKey: "d_field_fechaaplicacion", Label: "Fecha aplicación", Type: "date" },
            { Field: "FechaVencimientoCargo", LabelLangKey: "d_field_fechavencimiento", Label: "Fecha vencimiento", Type: "date" }
        ]
    }

    protected GridOnSyncData() {
        this.forceDownloadData = true;
        return super.GridOnSyncData();
    }

    protected async GridGetData() {
        // console.warn("GridGetData"); // FIXME Al crear la ventana, se repiten dos veces las peticiones. Origen > VentanaGrid, SelectControlAño
        if (this.dataPagosBySchool.size == 0 || this.forceDownloadData) {
            const res = await this.GetPagosRecibidosList();
            let hasError: boolean
            res.forEach((d) => {
                if (!hasError && d.Resultado <= 0) {
                    hasError = true
                }
                if (d.Resultado > 0) {
                    this.dataPagosBySchool.set(d.Resultado, d.Datos)
                }
            })
            if (hasError) {
                this.notificacion._Mostrar(_L("general.notif_fail_infoupdate"), "ADVERTENCIA")
            }
        }
        const monthFilter = this.comboMonth._dataSelected
        const dataFilter: IPagoRecibidoDetalle[] = []

        this.dataPagosBySchool.forEach((pagosEscuela, idEscuela) => {
            pagosEscuela.forEach(p => {
                const dt = new DateV2(p.FechaPago)._SetTimeZoneByIdSchool(idEscuela)
                const isValid = monthFilter.some(f => (dt.getFullYear() == f.Year && dt.getMonth() == f.Month))
                if (isValid) {
                    dataFilter.push(p)
                }
            })
        })
        setTimeout(() => {
            this.ctrlTabla._MenuTopDefault._Refresh();
        });
        return dataFilter;
    }

    // ***********************************************************************
    // Get data
    // ***********************************************************************

    private CalcularTotal_Tabla(datos: Table.TDataItemTableAux<IPagoRecibidoDetalle, any>[]): number {
        return datos.reduce<number>((total, itemTablePago) => {
            total += itemTablePago.data.Valor;
            return total;
        }, 0)
    }

    private CalcularTotal_Data(datos: Pick<IPagoRecibidoDetalle, "Valor">[]): number {
        return datos.reduce<number>((total, d) => (total + d.Valor), 0)
    }

    // private CalcularTotal<T, Field extends TOnlyKeysTypeof<T, number>>(datos: T[], field: Field): number {
    //     return datos.reduce<number>((total, item) => {
    //         total += (item[field] as number);
    //         return total;
    //     }, 0)
    // }

    // ***********************************************************************
    // Data final things
    // ***********************************************************************

    private async GetPagosRecibidosList(): Promise<DataDRequest.IRequestResponseA<IPagoRecibidoDetalle[]>[]> {
        // const escuelas = [..._DiccEscuela.values()]
        const result: DataDRequest.IRequestResponseA<IPagoRecibidoDetalle[]>[] = []
        const dictAlumnos = this.bolIncluyeExAlumnos ? _DICC_ALUMNO_FULL : _DICC_ALUMNO
        for (let { IdKinder, Nombre: NombreEscuela, ZonaHoraria } of this.kinders) {
            const pagosrecibidos: IPagoRecibidoDetalle[] = []
            const res = await _FinanzasObtenerPagosRecibidos(IdKinder)
            if (res.Resultado <= 0) {
                result.push(res as any)
                continue
            }
            for (const cargoPago of res.Datos) {
                const alumno: Entidad.IAlumno = dictAlumnos.get(cargoPago.IdAlumno)

                if (!alumno) {
                    // console.warn("-d", "Student no found", IdKinder, cargoPago)
                    continue
                }
                // const escuela = _DiccEscuela.get(alumno.IdKinder)
                let totalCobrar = 0 // cargo + recargo + comisión
                let totalRestar = 0 // totalDescuento, totalCobrado
                let totalRecargo = 0
                let totalCobrado = 0 // pago_parcial + pago_completo
                let totalDescuento = 0
                let totalComision = 0
                let totalFaltante = 0

                const refCargoPago: IPagoRecibidoCargo = <IPagoRecibidoCargo>{ // REMOVER?
                    ...cargoPago,
                    // NombreCompletoAlumno: alumno.NombreCompleto,
                    // StrEscuela: NombreEscuela,
                    Detalles: [],
                }

                for (const det of cargoPago.Detalles) {
                    switch (det.Categoria) {
                        case CCategoriaMov.PagoCompleto:
                        case CCategoriaMov.PagoParcial:
                            totalCobrado += det.Valor;
                            // detalleResult["PadreCargo"] = <any>cargoPago;
                            const detalleResult: IPagoRecibidoDetalle = UIUtilGeneral._ObjectAddGetters(<IPagoRecibidoDetalle>{
                                ...det,
                                IDFolio: cargoPago.Id.toString().padStart(6, "0"),
                                StrMetodoPago: DataModuloMain._GetReqDataMapByName("FinanzaMetodoPago").get(det.IdMetodoPago)?.Nombre || UIUtilLang._GetUIString("general", "nodisponible"),
                                KinderFiltro: [IdKinder], // NOTE (1) Los pagos van a "cambiar de escuela" si se cambia al alumno. (2) Los pagos no se verán cuando el alumno no esté
                                PadreCargo: refCargoPago,
                            }, {
                                ValorCargo: () => totalCobrar,
                                ConceptoCargo: () => cargoPago.Concepto,
                                ValorFaltanteCargo: () => totalFaltante, // refCargoPago.ValorFaltante,
                                DescuentoTotalCargo: () => totalDescuento, // refCargoPago.DescuentoTotal,
                                FechaAplicacionCargo: () => cargoPago.FechaAplicacion,
                                FechaVencimientoCargo: () => cargoPago.FechaVencimiento,
                                FechaPago: () => det.FechaAplicacion,
                                StrEscuela: () => NombreEscuela,
                                NombreCompletoAlumno: () => alumno.NombreCompleto,
                                ZonaHoraria: () => ZonaHoraria,
                                AlumnoEstado: () => alumno.IdChildMovimiento,
                            })
                            refCargoPago.Detalles.push(detalleResult);
                            pagosrecibidos.push(detalleResult);
                            break;
                        case CCategoriaMov.Descuento:
                            // refCargoPago.DescuentoTotal += det.Valor;
                            totalDescuento += det.Valor;
                            break;
                        case CCategoriaMov.Morosidad:
                            totalRecargo += det.Recargo;
                            break;
                        case CCategoriaMov.Comision:
                            totalComision += det.Valor // DOTEST
                            break;
                    }
                }
                const decimalNumbersLength = 2; // todos los numeros deberian tener <= 2 decimales;
                //se eleva el 10 a la cantidad de números decimales que hay
                //para tener un numero con la misma cantidad de ceros que decimales
                const fixNum = 10 ** decimalNumbersLength;
                // se toman los números después del punto
                totalCobrar = ((cargoPago.Valor * fixNum) + (totalRecargo * fixNum) + (totalComision * fixNum)) / fixNum
                totalRestar = ((totalDescuento * fixNum) + (totalCobrado * fixNum)) / fixNum
                totalFaltante = ((totalCobrar * fixNum) - (totalRestar * fixNum)) / fixNum;
            }
            result.push({
                Resultado: IdKinder,
                Datos: pagosrecibidos
            })
        }
        return result
    }

    protected GRID_GetExportarConfig(dataGrid: IPagoRecibidoDetalle[]): IConfigGridExcelExport<any> {
        type IDataToExport = Pick<IPagoRecibidoDetalle,
            "IDFolio" |
            "NombreCompletoAlumno" |
            "ConceptoCargo" |
            "ValorCargo" |
            "DescuentoTotalCargo" |
            "ValorFaltanteCargo" |
            "Valor" |
            "StrMetodoPago" |
            "FolioPago" |
            "FechaPago" |
            "FechaAplicacionCargo" |
            "FechaVencimientoCargo" |
            "StrEscuela"
        > & { _valor: number };

        const idsEscuelas = [...new Set(dataGrid.map(d => d.KinderFiltro[0]))];

        return <IConfigGridExcelExport<IDataToExport>>{
            IdsEscuelas: idsEscuelas,
            ColumnsConfig: this.ctrlTabla
                ._InfoColumns
                .filter(d => (d.Field != "StrEscuela"))
                .map<ExcelThings.IColumnToExcelExportFileConfig<IDataToExport>>(d => ({
                    Field: d.Field as keyof IDataToExport,
                    HeaderTag: d.Label,
                    WidthCell: d.Field == "NombreCompletoAlumno" ? 35 : 25
                })),
            OnGetDataBySheets: async () => {
                let groupedData: Map<number, IDataToExport[]> = new Map(idsEscuelas.map(idEscuela => ([idEscuela, []])));

                dataGrid.forEach(d => {
                    const idEscuela = d.KinderFiltro[0];
                    let datosEnEscuela = groupedData.get(idEscuela);
                    datosEnEscuela.push({
                        IDFolio: d.IDFolio,
                        NombreCompletoAlumno: d.NombreCompletoAlumno,
                        ConceptoCargo: d.ConceptoCargo,
                        ValorCargo: UIUtilFormat._CurrencyFmt(d.ValorCargo) as any,
                        DescuentoTotalCargo: UIUtilFormat._CurrencyFmt(d.DescuentoTotalCargo || 0) as any,
                        ValorFaltanteCargo: UIUtilFormat._CurrencyFmt(d.ValorFaltanteCargo) as any,
                        Valor: UIUtilFormat._CurrencyFmt(d.Valor) as any,
                        _valor: d.Valor,
                        StrMetodoPago: d.StrMetodoPago,
                        FolioPago: d.FolioPago,
                        FechaPago: UIUtilTime._DateFormatStandarFixTimeZone(d.FechaPago, d.ZonaHoraria, "dd/mm/yyyy h24:mm"),
                        FechaAplicacionCargo: UIUtilTime._DateFormatStandarFixTimeZone(d.FechaAplicacionCargo, d.ZonaHoraria),
                        FechaVencimientoCargo: UIUtilTime._DateFormatStandarFixTimeZone(d.FechaVencimientoCargo, d.ZonaHoraria),
                        StrEscuela: d.StrEscuela, // Sin columna
                    })
                })

                return Array.from(groupedData)
                    .map(([idEscuela, datosEscuela]) => ({
                        IdSheet: idEscuela,
                        SheetName: datosEscuela[0].StrEscuela,
                        Data: datosEscuela,
                        ExtraPie: [{
                            Label: _L("finanzaspagosrecibidos.tag_totalpagado"),
                            Value: UIUtilFormat._CurrencyFmt(this.CalcularTotal_Data(datosEscuela.map(d => ({ "Valor": d._valor })))),
                            Alignment: "right"
                        }]
                    }));
            },
            OnGetEscuelasTagInSheet: (datos) => datos[0].StrEscuela
        }
    }
}
